import { render, staticRenderFns } from "./page-params.vue?vue&type=template&id=45649561&scoped=true"
import script from "./page-params.vue?vue&type=script&lang=js"
export * from "./page-params.vue?vue&type=script&lang=js"
import style0 from "./page-params.vue?vue&type=style&index=0&id=45649561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45649561",
  null
  
)

export default component.exports